import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent } from "firebase/analytics";
import { HeartBank } from "../../../managers/HeartBank.ts";

import template from "./sw-home.mjs";
import QRCode from "qrcode";
import Strings from "../../../models/Strings.json";
import { HB_VAULT, LANGUAGE, isApple } from "../../global.ts";
import { SwMovie } from "../../sw-footer/sw-movie/sw-movie.ts";

import POSTER from "../../../public/poster.png";
import FRONT from "../../../public/front.png";
import BACK from "../../../public/back.png";
import CODE from "../../../public/heartbank.png";

const strings: any = Strings;

export class SwHome extends HTMLElement {
    private heartbank = new HeartBank();
    private componentTrace: PerformanceTrace;
    private buddha: HTMLVideoElement;
    private code: HTMLImageElement;
    private movie = document.querySelector("sw-movie") as SwMovie;

    private poster: File | null = null;
    private front: File | null = null;
    private back: File | null = null;
    private qr: File | null = null;

    private link = "https://bedok.siliconwat.org";

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-home");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.buddha = this.querySelector("video")!;
        this.code = this.querySelector("#qr_code")!;
    }

    connectedCallback() {
        // this.link =
        //     HB_VAULT +
        //     `/carnelian/1?lang=${strings.language[LANGUAGE]}&origin=${
        //         this.heartbank.isRunningAsPWA() ? "pwa" : "web"
        //     }&o=1&a=0`;
        this.share();
        this.getFiles(); // cache files early

        (this.buddha.parentElement as HTMLElement).addEventListener(
            "click",
            (event: Event) => {
                // if (this.buddha.paused) this.buddha.play();
                // else this.buddha.pause();
                this.movie.show();
                logEvent(analytics, "buddha");
            }
        );

        setInterval(() => {
            if (this.buddha.paused) this.buddha.play();
        }, 1000 * 60); // 1 minute

        const b = this.code.parentElement as HTMLPictureElement;
        b.addEventListener("click", async (event: Event) => {
            await navigator.clipboard.writeText(this.link);
            this.dispatchEvent(
                new CustomEvent<{ info: string }>("sw-banner", {
                    bubbles: true,
                    detail: {
                        info: strings.copied[LANGUAGE]
                    }
                })
            );

            try {
                const text = `${strings.gift[LANGUAGE]}\n\n${strings.hero2[LANGUAGE]}\n`;
                await this.getFiles();
                await navigator.share({
                    title: strings.title2[LANGUAGE],
                    text,
                    url: "https://bedok.siliconwat.org",
                    files: isApple
                        ? [this.poster!, this.front!, this.back!, this.qr!]
                        : [] // for andoid, show file but won't show text or url
                });
            } catch {
                // ignore errors
            }

            logEvent(analytics, "copy", { link: this.link });
        });

        // this.querySelectorAll("img").forEach((element: HTMLImageElement) => {
        //     element.addEventListener("click", async (event: Event) => {
        //         const link = "https://bedok.siliconwat.org";
        //         await navigator.clipboard.writeText(link);
        //         this.dispatchEvent(
        //             new CustomEvent<{ info: string }>("sw-banner", {
        //                 bubbles: true,
        //                 detail: {
        //                     info: strings.copied[LANGUAGE]
        //                 }
        //             })
        //         );
        //         logEvent(analytics, "copy", { link });
        //     });
        // });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    show() {
        this.classList.remove("hidden");
    }

    hide() {
        this.classList.add("hidden");
    }

    play() {
        if (this.buddha.paused) {
            this.buddha.play();
        }
    }

    pause() {
        if (!this.buddha.paused) {
            this.buddha.pause();
        }
    }

    private share() {
        QRCode.toDataURL(
            this.link,
            {
                width: 1000,
                errorCorrectionLevel: "L",
                type: "image/png",
                margin: 0,
                color: {
                    dark: "#fff",
                    light: "#0000"
                }
            },
            (error: Error | null | undefined, url: string) => {
                if (error) {
                    console.error("Error generating QR Code:", error);
                } else {
                    this.code.src = url;
                }
            }
        );
    }

    private async getFiles() {
        if (!this.poster) {
            const response = await fetch(POSTER, { mode: "cors" });
            const poster = await response.blob();
            this.poster = new File([poster], "Bedok.AI.poster.png", {
                type: "image/png"
            });
        }

        if (!this.front) {
            const response = await fetch(FRONT, { mode: "cors" });
            const front = await response.blob();
            this.front = new File([front], "Bedok.AI.frontcard.png", {
                type: "image/png"
            });
        }

        if (!this.back) {
            const response = await fetch(BACK, { mode: "cors" });
            const back = await response.blob();
            this.back = new File([back], "Bedok.AI.backcard.png", {
                type: "image/png"
            });
        }

        if (!this.qr) {
            const response = await fetch(CODE, { mode: "cors" });
            const qr = await response.blob();
            this.qr = new File([qr], "Bedok.AI.qrcode.png", {
                type: "image/png"
            });
        }
    }
}
